var _path, _rect, _rect2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNonVerifiedIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.2281 11.9961L21.8501 10.0761C22.3151 8.63905 21.6681 7.07602 20.3231 6.38901L18.5261 5.471L17.6081 3.67398C16.9211 2.32896 15.358 1.68095 13.921 2.14695L12 2.76796L10.08 2.14595C8.64295 1.68095 7.07993 2.32796 6.39292 3.67298L5.47391 5.47L3.67688 6.38901C2.33186 7.07602 1.68485 8.63905 2.14986 10.0761L2.77187 11.9961L2.14986 13.9161C1.68485 15.3531 2.33186 16.9162 3.67688 17.6032L5.47391 18.5212L6.39192 20.3182C7.07893 21.6632 8.64195 22.3112 10.079 21.8452L12 21.2242L13.92 21.8462C15.357 22.3112 16.9201 21.6642 17.6071 20.3192L18.5251 18.5222L20.3221 17.6042C21.6671 16.9172 22.3151 15.3541 21.8491 13.9171L21.2281 11.9961Z",
    fill: "#EB4E3D"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 15.957,
    y: 9.35742,
    width: 9.4762,
    height: 1.98408,
    rx: 0.992038,
    transform: "rotate(135 15.957 9.35742)",
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 9.29297,
    y: 8,
    width: 9.4762,
    height: 1.98408,
    rx: 0.992038,
    transform: "rotate(45 9.29297 8)",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNonVerifiedIcon);
export default __webpack_public_path__ + "static/media/Non-verified-icon.86dafde6542b249b63f9a604b0cebfaf.svg";
export { ForwardRef as ReactComponent };